import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API_URL } from "./api";

const Ctx = createContext({ branding: null, refresh: () => {} });

export const assetUrl = (rel) => (rel ? `${API_URL}/${rel}` : null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);
  const refresh = useCallback(
    () => api.get("/settings/branding").then((r) => setBranding(r.data)).catch(() => {}),
    []
  );
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ branding, refresh }}>{children}</Ctx.Provider>;
}

export const useBranding = () => useContext(Ctx);
